<template>
	<by-container :showLoading="showLoading" :showNotContent="showNotContent">
		<div class="wrap clearfloat">
			<div class="memberW newsW clearfloat">
				<div class="left">
					<baidu-map
						class="map"
						:style="{ height: mapHeight }"
						:minZoom="map.minZoom"
						:zoom="map.zoom"
						:center="map.center"
						@ready="handler"
					></baidu-map>
				</div>
				<div class="right">
					<h2>村站列表</h2>
					<ul class="newsWqlist">
						<li v-for="(li,index) in list" :key="index" @click="siteClick(li)">
							<div class="clearfloat site_list" href="">
								<div class="newsWqPic mr-15">
									<div class="pic"><img :src="li.coverKey" alt="" /></div>
								</div>
								<div class="cont" style="width:150px">
									<h3 class="over_hidden">{{li.siteName}}</h3>
									<p>所在地址：{{li.townName}} {{li.villageName}}</p>
									<p>联系电话：{{li.phone}}</p>
									<p class="over_hidden" :title="li.siteUserName">联系人：{{li.siteUserName}}</p>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</by-container>
</template>

<script>
import styleJson from '@/common/lib/BaiduMapJSON.js';
export default {
	components: {
		// 引入组件
	},
	data() {
		return {
			showLoading: false, //页面加载状态
			showNotContent: false, //是否显示空

			// 地图相关
			mapHeight: '600px',
			map: {
				center: { lng: 108.66575 , lat:  24.06617 },
				zoom: 11,
				minZoom: 10,
				show: true,
				dragging: true
			},
			
			// 村站列表
			list:[
				// { img:"/static/img/2.png",title:"惠民综合超市",town:"温泉镇",village:"中兴村",tel:"13888888888",name:"张三" },
			]
		};
	},
	props: {
		// 上级页面传递的数据
	},
	computed: {
		// 计算属性
	},
	created() {
		// 实例初始化
	},
	beforeCreate() {
		// 实例初始化之后
	},
	mounted() {
		// 实例被挂载后调用
	},
	updated() {
		// 数据更新后调用
	},
	activated() {
		// 缓存页面显示后调用
	},
	deactivated() {
		// 缓存页面隐藏后调用
	},
	methods: {
		// 获取数据
    getData() {
      let reqInfo = {};
      this.showLoading = true;
      this.$api.Home.getSiteList(reqInfo, (res) => {
          this.baiduMap.clearOverlays();
          let resData = res.data;
          this.showLoading = false;
					this.list = resData;
         for(let i = 0;i<resData.length;i++){
          let point = new BMap.Point(res.data[i].longitude*1, res.data[i].latitude*1);
          let marker = new BMap.Marker(point)
          this.baiduMap.addOverlay(marker);
					let content = res.data[i];
          this.addOfficialClickHandler(content, marker);
        }
      },err=>{
          this.showLoading = false;
          this.$tool.tipsFun.msgError(err);  
      });
    },
		siteClick(item){
			let point = new BMap.Point(item.longitude*1, item.latitude*1);
      var opts = {
        width: 300,
        height: 140,
      };
      let imgDiv = '';
      let str = `
				<div style="display:flex;width:100%;height:100%;min-height: 120px;">
					<div style="height:100%;flex:1">
						<p title="${
              item.siteName
            }" style="width:100%;margin:10px 0;font-size:14px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">站点名称:  ${
        item.siteName
      }</p>
						<p  style="margin:10px 0;font-size:14px;">所属乡镇:  ${
              item.townName == null ? "" : item.townName
            }</p>
						<p style="margin:10px 0;font-size:14px;">站点类型:  ${item.typeName == null?"暂无类型":item.typeName}</p>
					</div>
				</div>
      `;
      var infoWindow = new BMap.InfoWindow(str, opts); // 创建信息窗口对象
			 this.baiduMap.openInfoWindow(infoWindow, point);
		},
		// 添加正式点击事件
    addOfficialClickHandler(content, marker) {
      let _this = this;
      marker.addEventListener("click", (e) => {
        this.dialogData = content;
        this.dialogId = content.id;
        this.openOfficialInfo(content, e);
      });
    },
	    // 正式数据信息框
    openOfficialInfo(content, e) {
      let _this = this;
      var opts = {
        width: 300,
        height: 140,
      };
      let imgDiv = '';
      let str = `
				<div style="display:flex;width:100%;height:100%;min-height: 120px;">
					<div style="height:100%;flex:1">
						<p title="${
              content.siteName
            }" style="width:100%;margin:10px 0;font-size:14px;text-overflow: ellipsis;white-space: nowrap;overflow: hidden;">站点名称:  ${
        content.siteName
      }</p>
						<p  style="margin:10px 0;font-size:14px;">所属乡镇:  ${
              content.townName == null ? "" : content.townName
            }</p>
						<p style="margin:10px 0;font-size:14px;">站点类型:  ${content.typeName == null?"暂无类型":content.typeName}</p>
					</div>
				</div>
      `;
      var p = e.target;
      var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
      var infoWindow = new BMap.InfoWindow(str, opts); // 创建信息窗口对象
      this.baiduMap.openInfoWindow(infoWindow, point); //开启信息窗口
      setTimeout(() => {
        var btn = document.getElementById("pid");
        btn.addEventListener("click", function () {
          	_this.$openWin(
            '站点详情',
            itemDetail2,
            { itemId:content.userId,type:'offical'},
            () => {
            },{
              h:'450px'
            }
          );
        });
      }, 0);
    },
		handler({ BMap, map }) {
			let _this = this;
			this.baiduMap = map;
			this.baiduBMap = BMap;

			let bdary = new BMap.Boundary();
			// 鼠标缩放

			map.enableScrollWheelZoom(true);

			bdary.get('台州市', rs => {
				//获取行政区域
				map.clearOverlays(); //清除地图覆盖物

				var ply = new BMap.Polyline(rs.boundaries[0], {
					strokeWeight: 2,
					strokeColor: '#4A7300',
					fillColor: ''
				});
				map.addOverlay(ply);
				ply.disableMassClear();
				this.getData();
			});
			var bs = map.getBounds(); //获取可视区域
			var bssw = bs.getSouthWest(); //可视区域左下角
			var bsne = bs.getNorthEast();
			// 控制显示区域
			var b = new BMap.Bounds(new BMap.Point(bssw.lng, bssw.lat), new BMap.Point(bsne.lng, bsne.lat));
			try {
				// BMapLib.AreaRestriction.setBounds(map, b);
			} catch (e) {
				console.log(e);
			}
		}
	},
	watch: {
		// 数据监听及回调
	}
};
</script>

<style scoped="scoped">
	/* 隐藏左下角百度logo */
	/deep/ .anchorBL { display: none;}
	
	
	.left{margin-top: 30px;border:1px solid #333333}
	
	.right{margin-top: 30px;height: 600px;overflow-y: auto;}
	.memberW .right h2{margin-top: 0;}
	.newsWqlist .pic{width: 180px;}
	.newsWqlist .pic img{height: 80px;}
	.newsWqlist li a .cont h3{color: #333333;font-size: 16px}
	.newsWqlist li a .cont p{font-size: 13px;line-height: 20px;}
	.site_list{ display: flex;user-select: none;cursor: pointer;}

	.over_hidden{ overflow: hidden; width: 100%; text-overflow: ellipsis; white-space: nowrap;  }
</style>
